import Repository from './Repository'

const resource = 'task-users'

export default {
  getTaskUsers (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  },
  createTaskUser (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}`, data)
  },
  createTaskUserList (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}-list`, data)
  },
  updateTaskUser (tenantId, taskUserId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}/${taskUserId}`, data)
  },
  updateAllTaskUser (tenantId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}-list`, data)
  },
  deleteTaskUser (tenantId, taskUserId) {
    return Repository.delete(`tenants/${tenantId}/${resource}/${taskUserId}`)
  },
  exportTaskUser (tenantId, params) {
    return Repository.get(`exports/tenants/${tenantId}/schedule-rider/pdf`, {
      responseType: 'blob',
      params: params
    })
  },
  exportICADocuent (tenantId, params) {
    return Repository.get(`exports/tenants/${tenantId}/ica/pdf`, {
      responseType: 'blob',
      params: params
    })
  }
}
